/** Short site label (nav, copyright, titles). */
export const SITE_SHORT_NAME = "P0R74L";

/** Category list: auto load on scroll for this many pages, then "load more" only. */
export const CATEGORY_INFINITE_SCROLL_MAX_PAGES = 25;

export function documentTitlePage(page: string): string {
  return `${page} - ${SITE_SHORT_NAME}`;
}

export function documentTitleArticle(articleTitle: string): string {
  return `${articleTitle} - ${SITE_SHORT_NAME}`;
}

export function documentTitleHome(): string {
  return `${SITE_SHORT_NAME} | Vijesti`;
}

export function documentTitleCategory(categoryName: string): string {
  return `${categoryName} - ${SITE_SHORT_NAME}`;
}
